import { loadStripe } from '@stripe/stripe-js';

// Environment variables
const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
const STRIPE_SECRET_KEY = import.meta.env.VITE_STRIPE_SECRET_KEY;
const SURGE_PLAN_PRICE_ID = import.meta.env.VITE_SURGE_PLAN_PRICE_ID;

// Initialize Stripe
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Stripe configuration
export const STRIPE_PLANS = {
  surge: {
    priceId: SURGE_PLAN_PRICE_ID,
    name: 'Surge Plan',
    price: 129.99,
    interval: 'monthly'
  }
};

// Get Stripe price ID for a plan
export const getStripePriceId = (planId: string): string | null => {
  switch (planId) {
    case 'surge':
      return STRIPE_PLANS.surge.priceId;
    default:
      return null;
  }
};

// Check if Stripe is configured
export const isStripeConfigured = (): boolean => {
  return !!(STRIPE_PUBLISHABLE_KEY && SURGE_PLAN_PRICE_ID);
}; 